export const QuestionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g id="akar-icons:question">
        <g id="Group">
          <path
            id="Vector"
            d="M12.5 22.708C18.0228 22.708 22.5 18.2309 22.5 12.708C22.5 7.18516 18.0228 2.70801 12.5 2.70801C6.97715 2.70801 2.5 7.18516 2.5 12.708C2.5 18.2309 6.97715 22.708 12.5 22.708Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            id="Vector_2"
            d="M10.5 9.19201C11 8.20201 11.5 7.70801 12.5 7.70801C13.746 7.70801 14.5 8.69701 14.5 9.68601C14.5 10.675 14 11.169 12.5 12.159V13.708M12.5 17.208V17.708"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>
      </g>
    </svg>
  );
};
